<template>
  <div
    class="toast-container"
    :class="{ 'is-mobile': isMobile }"
    @mouseenter="stopTimer"
    @mouseleave="notifyStartTimer"
  >
    <div class="toast" :class="[`toast-${toast.type}`, position]">
      <div class="toast-icon">
        <BaseSvg :src="variantIcon[toast?.type ?? 'error']" />
      </div>
      <div class="toast-content">
        <div class="toast-title">
          {{ toast.title }}
        </div>
        <div v-if="toast.content" class="toast-description">
          {{ toast.content }}
        </div>
        <template v-if="!!slots.default">
          <slot />
        </template>
      </div>
      <div class="toast-close" @click="removeItem">
        <BaseSvg :src="CloseIcon" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onBeforeUnmount, onMounted, useSlots } from 'vue';
import { CheckIcon, CloseIcon, ErrorIcon, InfoIcon, WarningIcon } from '@/assets/icons';
import BaseSvg from './BaseSvg.vue';
import type { IToast } from '@/types/components';
export interface Props {
  isMobile?: boolean;
  toast: IToast;
  position?: 'top-left' | 'top-right' | 'bottom-right' | 'bottom-left';
}

const props = withDefaults(defineProps<Props>(), {
  isMobile: false,
  position: 'top-right',
});
const emit = defineEmits(['close']);
let interval: number = 0;
const elapsedTime = ref<number>(0);
const variantIcon = ref({
  success: CheckIcon,
  error: ErrorIcon,
  warning: WarningIcon,
  info: InfoIcon,
});

const slots = useSlots();

const notifyStartTimer = () => {
  interval = window.setInterval(() => {
    elapsedTime.value += 1;
    const duration = props.toast?.duration ?? 7;
    if (elapsedTime.value === duration) {
      removeItem();
    }
  }, 1000);
};
const removeItem = () => {
  clearInterval(interval);
  emit('close');
};

const stopTimer = () => {
  clearInterval(interval);
};

onMounted(() => {
  notifyStartTimer();
});

onBeforeUnmount(() => {
  clearInterval(interval);
});
</script>

<style lang="scss" scoped src="./styles/toast.scss" />
